module.exports = __webpack_public_path__ + "img/info.52c30fbd.svg";